import { createMuiTheme } from "@material-ui/core/styles";

export default createMuiTheme({
  palette: {
    primary: {
      main: "#1d1d1b",
    },
  },
  overrides: {
    MuiTableCell: {
      root: {
        padding: "18px 18px",
        "&:first-child": {
          paddingLeft: "16px",
        },
        "&:last-child": {
          minWidth: "100px",
        },
      },
    },
  },
  typography: {
    fontFamily: '"Andes"',
  },
});
